export default "__VITE_ASSET__b747a756__"